// Central store for all subscription objects to avoid circular dependencies
import type { GRPCSubcription } from './GRPCSubscriptionObject'
import type { GRPCSubscriptionPagedList } from './GRPCSubscriptionPagedList'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OBJECT_SUBSCRIPTIONS: Record<string, GRPCSubcription<any, any>> = {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LIST_SUBSCRIPTIONS: Record<string, GRPCSubscriptionPagedList<any, any>> = {}

// MultiGet subscription tracking - [tag, refString] tuple
export const MULTIGET_SUBSCRIPTIONS: Record<string, [string, string]> = {}
